<template>
  <div class="login-layout">
    <div class="login-card">
      <div class="login-header">
        <i class="fa-solid fa-qrcode"></i>
        <h1>Admin Login</h1>
      </div>

      <form @submit.prevent="login" class="login-form">
        <div class="form-group">
          <input
            type="text"
            placeholder="Email"
            v-model="email"
            required
            autocomplete="email"
          />
        </div>

        <div class="form-group">
          <input
            type="password"
            placeholder="Heslo"
            v-model="password"
            required
            autocomplete="current-password"
          />
        </div>

        <button type="submit" class="btn-login">
          <i class="fa-solid fa-right-to-bracket"></i>
          Prihlásenie
        </button>

        <div v-if="errorMessage" class="error-msg">
          <i class="fa-solid fa-circle-exclamation"></i>
          {{ errorMessage }}
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import AuthService from '@/services/auth'

export default {
  name: 'UserLogin',
  data() {
    return {
      email: '',
      password: '',
      errorMessage: ''
    }
  },
  methods: {
    login() {
      if (!this.email || !this.password) return
      AuthService.login(this.email, this.password)
        .then(response => {
          localStorage.setItem('token', response.data.token)
          localStorage.setItem('role', response.data.role)
          this.$router.push('/qr')
        })
        .catch(err => {
          this.errorMessage = err?.response?.data?.error || 'Prihlásenie zlyhalo'
        })
    }
  },
  mounted() {
    if (localStorage.getItem('token')) {
      this.$router.push('/qr')
    }
  }
}
</script>

<style scoped>
/* Background */
.login-layout {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)),
    url('@/assets/bg.png') center/cover no-repeat;
}

/* Card */
.login-card {
  background: rgba(255,255,255,0.95);
  backdrop-filter: blur(6px);
  padding: 40px 32px;
  border-radius: 18px;
  box-shadow: 0 12px 40px rgba(0,0,0,0.2);
  width: 100%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  gap: 22px;
}

/* Header */
.login-header {
  text-align: center;
}
.login-header h1 {
  margin-top: 10px;
  font-size: 24px;
  font-weight: 800;
  color: #0a2a47;
}
.login-header i {
  font-size: 42px;
  color: #369af1;
}

/* Form */
.login-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.form-group input {
  width: calc(100% - 28px);
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid #e6ebf2;
  font-size: 15px;
  outline: none;
  transition: border-color .2s;
}
.form-group input:focus {
  border-color: #369af1;
  box-shadow: 0 0 0 2px rgba(54,154,241,0.2);
}

/* Button */
.btn-login {
  background: #369af1;
  border: none;
  color: #fff;
  padding: 12px 14px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background .2s, transform .1s;
}
.btn-login:hover {
  background: #2f89d7;
  transform: translateY(-1px);
}

/* Error */
.error-msg {
  color: #b91c1c;
  font-size: 14px;
  text-align: center;
  margin-top: 8px;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
}

/* Responsive */
@media (max-width: 480px) {
  .login-card {
    padding: 28px 22px;
    gap: 16px;
  }
  .login-header h1 {
    font-size: 20px;
  }
}
</style>
